import React from 'react';
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import { ShimmerThumbnail, ShimmerCircularImage } from "react-shimmer-effects";
import { IoCaretDownSharp, IoCheckmarkSharp } from "react-icons/io5";

const SummativeReportLoader = () => {
  return (
    <ProfileLayout title={"Summative Report"}>
      <div className="d-flex align-items-center justify-content-center">
        <div style={{ width: '150px' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
      </div>
      <div className='border border-gray-200 rounded-3 pd-12 mg-t-15'>
        <div style={{ width: '50px' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
        <div className='d-flex align-items-center mg-t-5'>
          <div style={{ width: '20%' }} className='mg-r-10'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
          <div style={{ width: '20%' }} className='mg-r-10'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
          <div style={{ width: '20%' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
        </div>
        <div style={{ width: '70%' }} className='mg-t-5'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
        <div style={{ width: '90%' }} className='mg-t-5'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
      </div>

      <div className='border border-gray-200 rounded-3 pd-12 mg-t-15'>
        <div style={{ width: '50px' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
        <div className='d-flex align-items-center mg-t-5'>
          <div style={{ width: '20%' }} className='mg-r-10'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
          <div style={{ width: '20%' }} className='mg-r-10'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
          <div style={{ width: '20%' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
        </div>
        <div style={{ width: '70%' }} className='mg-t-5'><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
      </div>
      {
        Array.from({ length: 2 }).map((_, index) => {
          return ( 
            <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
              <div className="pd-l-20 mg-t-15 position-relative">
                <div className='position-absolute start-0' style={{ top: '-2px' }}><IoCaretDownSharp /></div>
                <div style={{ width: '170px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '80px' }} className='mg-t-8'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div className='bg-gray-400 rounded-3 pd-x-8 pd-y-6 mg-t-10'>
                  <div className='d-flex flex-1 align-items-center'>
                    <div className='shimmer-circular-img mg-r-10' style={{ marginTop: '-1px' }}><ShimmerCircularImage size={8} className="flex-1 mg-b-0" /></div>
                    <div className='flex-1'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                  </div>
                </div>
                <div style={{ width: '200px' }} className='mg-t-10'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div className='bg-gray-400 rounded-3 pd-x-8 pd-y-6 mg-t-10'>
                  <div className='d-flex flex-1 align-items-center'>
                    <div className='shimmer-circular-img mg-r-10' style={{ marginTop: '-1px' }}><ShimmerCircularImage size={8} className="flex-1 mg-b-0" /></div>
                    <div className='flex-1'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                  </div>
                </div>
                <div style={{ width: '200px' }} className='mg-t-10'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div className='bg-gray-400 rounded-3 pd-x-8 pd-y-6 mg-t-10'>
                  <div className='d-flex flex-1 align-items-center'>
                    <div className='shimmer-circular-img mg-r-10' style={{ marginTop: '-1px' }}><ShimmerCircularImage size={8} className="flex-1 mg-b-0" /></div>
                    <div className='flex-1'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }

      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div className="pd-l-20 mg-t-15 position-relative">
          <div className='position-absolute start-0' style={{ top: '-2px' }}><IoCaretDownSharp /></div>
          <div style={{ width: '170px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          {
            Array.from({ length: 3 }).map((_, index) => {
              return ( 
                <>
                <div style={{ width: '130px' }} className='mg-t-10'><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '150px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
    
                <div className='position-relative d-flex align-items-center mg-t-15'>
                  <div style={{ marginTop: '-4px' }}><IoCheckmarkSharp /></div>
                  <div style={{ width: '170px' }} className='mg-l-10'>
                    <ShimmerThumbnail height={12} className="rounded-5 mb-0" />
                  </div>
                </div>
                <div className='position-relative d-flex align-items-center mg-t-15'>
                  <div style={{ marginTop: '-4px' }}><IoCheckmarkSharp /></div>
                  <div style={{ width: '170px' }} className='mg-l-10'>
                    <ShimmerThumbnail height={12} className="rounded-5 mb-0" />
                  </div>
                </div>
                <div className='position-relative d-flex align-items-center mg-t-15'>
                  <div style={{ marginTop: '-4px' }}><IoCheckmarkSharp /></div>
                  <div style={{ width: '170px' }} className='mg-l-10'>
                    <ShimmerThumbnail height={12} className="rounded-5 mb-0" />
                  </div>
                </div>
              </>
              )
            })
          }
        </div>
      </div>

      <div className="mx-n-20 pd-x-20 pd-t-15">
        {
          Array.from({ length: 5 }).map((_, index) => {
            return ( 
              <>
                <div style={{ width: '60%' }} className={`mg-b-5 ${index === 0 ? '' : 'mg-t-15'}`}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
                <div style={{ width: '150px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
              </>
            )
          })
        }
      </div>

    </ProfileLayout>
  );
};

export default SummativeReportLoader;